export default "__VITE_ASSET__4fa69478__"